import { FileWriterBase } from './file-writer-base';
import { XmlWriterMapping } from './xml-writer-mapping';

export class XmlWriterProps extends FileWriterBase {
	writerMapping: XmlWriterMapping = new XmlWriterMapping({ tagName: 'Body' });

	constructor(init?: Partial<XmlWriterProps>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
